const GRADE = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
];
const GRADE_ZH = [
  {
    label: 'KG (幼儿园)',
    value: '0',
  },
  {
    label: '1年级',
    value: '1',
  },
  {
    label: '2年级',
    value: '2',
  },
  {
    label: '3年级',
    value: '3',
  },
  {
    label: '4年级',
    value: '4',
  },
  {
    label: '5年级',
    value: '5',
  },
  {
    label: '6年级',
    value: '6',
  },
  {
    label: '7年级',
    value: '7',
  },
  {
    label: '8年级',
    value: '8',
  },
  {
    label: '9年级',
    value: '9',
  },
  {
    label: '10年级',
    value: '10',
  },
  {
    label: '11年级',
    value: '11',
  },
];

const GRADE_EN = [
  {
    label: 'KG (Kindergarten)',
    value: '0',
  },
  {
    label: 'Grade 1',
    value: '1',
  },
  {
    label: 'Grade 2',
    value: '2',
  },
  {
    label: 'Grade 3',
    value: '3',
  },
  {
    label: 'Grade 4',
    value: '4',
  },
  {
    label: 'Grade 5',
    value: '5',
  },
  {
    label: 'Grade 6',
    value: '6',
  },
  {
    label: 'Grade 7',
    value: '7',
  },
  {
    label: 'Grade 8',
    value: '8',
  },
  {
    label: 'Grade 9',
    value: '9',
  },
  {
    label: 'Grade 10',
    value: '10',
  },
  {
    label: 'Grade 11',
    value: '11',
  },
];

// 英文年级-英文页面
const ENGLISH_GRADE_EN = [
  {
    label: 'KG (Kindergarten)',
    value: '0',
  },
  {
    label: 'Grade 1',
    value: '1',
  },
  {
    label: 'Grade 2',
    value: '2',
  },
  {
    label: 'Grade 3',
    value: '3',
  },
  {
    label: 'Grade 4',
    value: '4',
  },
  {
    label: 'Grade 5',
    value: '5',
  },
  {
    label: 'Grade 6',
    value: '6',
  },
  {
    label: 'Grade 7',
    value: '7',
  },
];

// 英文年级-中文页面
const ENGLISH_GRADE_ZH = [
  {
    label: 'KG (幼儿园)',
    value: '0',
  },
  {
    label: '1年级',
    value: '1',
  },
  {
    label: '2年级',
    value: '2',
  },
  {
    label: '3年级',
    value: '3',
  },
  {
    label: '4年级',
    value: '4',
  },
  {
    label: '5年级',
    value: '5',
  },
  {
    label: '6年级',
    value: '6',
  },
  {
    label: '7年级',
    value: '7',
  },
];

const CHINESE_LEVEL = [
  {
    label: '无中文学习经验',
    value: 'A',
  },
  {
    label: '零基础，听说流利',
    value: 'B',
  },
  {
    label: '<1年学习时间',
    value: 'C',
  },
  {
    label: '1-2年学习经验',
    value: 'D',
  },
  {
    label: '2+年学习经验',
    value: 'E',
  },
  {
    label: '中文为母语',
    value: 'F',
  },
];

const CHINESE_LEVEL_EN = [
  {
    label: 'No background',
    value: 'A',
  },
  {
    label: 'Can talk about simple topics',
    value: 'B',
  },
  {
    label: '<1 year of study',
    value: 'C',
  },
  {
    label: '1-2 years of study',
    value: 'D',
  },
  {
    label: '>2 years of study',
    value: 'E',
  },
  {
    label: 'Native speaker',
    value: 'F',
  },
];

const MOTHER_LANGUAGE = [
  {
    label: '常用语言-英语',
    value: 'B',
  },
  {
    label: '常用语言-日语',
    value: 'C',
  },
  {
    label: '常用语言-韩语',
    value: 'D',
  },
  {
    label: '常用语言-法语',
    value: 'E',
  },
  {
    label: '常用语言-德语',
    value: 'G',
  },
  {
    label: '常用语言-其他',
    value: 'F',
  },
];

const AGE_CHINESE_ZH = [
  {
    label: '3岁',
    value: '3',
  },
  {
    label: '4岁',
    value: '4',
  },
  {
    label: '5岁',
    value: '5',
  },
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
  {
    label: '13岁',
    value: '13',
  },
  {
    label: '14岁',
    value: '14',
  },
  {
    label: '15岁',
    value: '15',
  },
  {
    label: '16岁',
    value: '16',
  },
  {
    label: '17岁',
    value: '17',
  },
  {
    label: '18岁',
    value: '18',
  },
];
const AGE_CHINESE_EN = [
  {
    label: '3 years old',
    value: '3',
  },
  {
    label: '4 years old',
    value: '4',
  },
  {
    label: '5 years old',
    value: '5',
  },
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
  {
    label: '13 years old',
    value: '13',
  },
  {
    label: '14 years old',
    value: '14',
  },
  {
    label: '15 years old',
    value: '15',
  },
  {
    label: '16 years old',
    value: '16',
  },
  {
    label: '17 years old',
    value: '17',
  },
  {
    label: '18 years old',
    value: '18',
  },
];

// 数学年龄
const AGE_MATH_SERVICE_ZH = [
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
  {
    label: '13岁',
    value: '13',
  },
  {
    label: '14岁',
    value: '14',
  },
  {
    label: '15岁',
    value: '15',
  },
];

const AGE_MATH_SERVICE_EN = [
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
  {
    label: '13 years old',
    value: '13',
  },
  {
    label: '14 years old',
    value: '14',
  },
  {
    label: '15 years old',
    value: '15',
  },
];

// 英语年龄中文
const AGE_ENGLISH_SERVICE_ZH = [
  {
    label: '5岁',
    value: '5',
  },
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
];

// 英语年龄英文
const AGE_ENGLISH_SERVICE_EN = [
  {
    label: '5 years old',
    value: '5',
  },
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
];

// 数学-ZH-国家-学生年级映射
const MATH_ZH_COUNTRY_STUDENT_GRADE = {
  '+61': [
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
    {
      label: '7年级',
      age: '12',
      value: '7',
    },
    {
      label: '8年级',
      age: '13',
      value: '8',
    },
    {
      label: '9年级',
      age: '14',
      value: '9',
    },
    {
      label: '10年级',
      age: '15',
      value: '10',
    },
    {
      label: '11年级',
      age: '16',
      value: '11',
    },
  ],
  '+64': [
    {
      label: '2年级',
      age: '6',
      value: '2',
    },
    {
      label: '3年级',
      age: '7',
      value: '3',
    },
    {
      label: '4年级',
      age: '8',
      value: '4',
    },
    {
      label: '5年级',
      age: '9',
      value: '5',
    },
    {
      label: '6年级',
      age: '10',
      value: '6',
    },
    {
      label: '7年级',
      age: '11',
      value: '7',
    },
    {
      label: '8年级',
      age: '12',
      value: '8',
    },
    {
      label: '9年级',
      age: '13',
      value: '9',
    },
    {
      label: '10年级',
      age: '14',
      value: '10',
    },
    {
      label: '11年级',
      age: '15',
      value: '11',
    },
  ],
  '+65': [
    {
      label: '幼儿园',
      age: '5',
      value: '0',
    },
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
    {
      label: '7年级',
      age: '12',
      value: '7',
    },
    {
      label: '8年级',
      age: '13',
      value: '8',
    },
    {
      label: '9年级',
      age: '14',
      value: '9',
    },
    {
      label: '10年级',
      age: '15',
      value: '10',
    },
  ],
  other: [
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
    {
      label: '7年级',
      age: '12',
      value: '7',
    },
    {
      label: '8年级',
      age: '13',
      value: '8',
    },
    {
      label: '9年级',
      age: '14',
      value: '9',
    },
    {
      label: '10年级',
      age: '15',
      value: '10',
    },
    {
      label: '11年级',
      age: '16',
      value: '11',
    },
  ],
};

// 数学-EN-国家-学生年级映射
const MATH_EN_COUNTRY_STUDENT_GRADE = {
  '+61': [
    {
      label: 'Year 1',
      age: '6',
      value: '1',
    },
    {
      label: 'Year 2',
      age: '7',
      value: '2',
    },
    {
      label: 'Year 3',
      age: '8',
      value: '3',
    },
    {
      label: 'Year 4',
      age: '9',
      value: '4',
    },
    {
      label: 'Year 5',
      age: '10',
      value: '5',
    },
    {
      label: 'Year 6',
      age: '11',
      value: '6',
    },
    {
      label: 'Year 7',
      age: '12',
      value: '7',
    },
    {
      label: 'Year 8',
      age: '13',
      value: '8',
    },
    {
      label: 'Year 9',
      age: '14',
      value: '9',
    },
    {
      label: 'Year 10',
      age: '15',
      value: '10',
    },
    {
      label: 'Year 11',
      age: '16',
      value: '11',
    },
  ],
  '+64': [
    {
      label: 'Year 2',
      age: '6',
      value: '2',
    },
    {
      label: 'Year 3',
      age: '7',
      value: '3',
    },
    {
      label: 'Year 4',
      age: '8',
      value: '4',
    },
    {
      label: 'Year 5',
      age: '9',
      value: '5',
    },
    {
      label: 'Year 6',
      age: '10',
      value: '6',
    },
    {
      label: 'Year 7',
      age: '11',
      value: '7',
    },
    {
      label: 'Year 8',
      age: '12',
      value: '8',
    },
    {
      label: 'Year 9',
      age: '13',
      value: '9',
    },
    {
      label: 'Year 10',
      age: '14',
      value: '10',
    },
    {
      label: 'Year 11',
      age: '15',
      value: '11',
    },
  ],
  '+65': [
    {
      label: 'Kindergarten',
      age: '5',
      value: '0',
    },
    {
      label: 'Grade 1',
      age: '6',
      value: '1',
    },
    {
      label: 'Grade 2',
      age: '7',
      value: '2',
    },
    {
      label: 'Grade 3',
      age: '8',
      value: '3',
    },
    {
      label: 'Grade 4',
      age: '9',
      value: '4',
    },
    {
      label: 'Grade 5',
      age: '10',
      value: '5',
    },
    {
      label: 'Grade 6',
      age: '11',
      value: '6',
    },
    {
      label: 'Grade 7',
      age: '12',
      value: '7',
    },
    {
      label: 'Grade 8',
      age: '13',
      value: '8',
    },
    {
      label: 'Grade 9',
      age: '14',
      value: '9',
    },
    {
      label: 'Grade 10',
      age: '15',
      value: '10',
    },
  ],
  other: [
    {
      age: '6',
      label: 'Grade 1',
      value: '1',
    },
    {
      age: '7',
      label: 'Grade 2',
      value: '2',
    },
    {
      age: '8',
      label: 'Grade 3',
      value: '3',
    },
    {
      age: '9',
      label: 'Grade 4',
      value: '4',
    },
    {
      age: '10',
      label: 'Grade 5',
      value: '5',
    },
    {
      age: '11',
      label: 'Grade 6',
      value: '6',
    },
    {
      age: '12',
      label: 'Grade 7',
      value: '7',
    },
    {
      age: '13',
      label: 'Grade 8',
      value: '8',
    },
    {
      age: '14',
      label: 'Grade 9',
      value: '9',
    },
    {
      age: '15',
      label: 'Grade 10',
      value: '10',
    },
    {
      age: '16',
      label: 'Grade 11',
      value: '11',
    },
  ],
};

// 英文-CH-国家-学生年级映射
const ENGLISH_CH_COUNTRY_STUDENT_GRADE = {
  '+61': [
    {
      label: '幼儿园',
      age: '5',
      value: '0',
    },
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
  ],
  '+64': [
    {
      label: '1年级',
      age: '5',
      value: '1',
    },
    {
      label: '2年级',
      age: '6',
      value: '2',
    },
    {
      label: '3年级',
      age: '7',
      value: '3',
    },
    {
      label: '4年级',
      age: '8',
      value: '4',
    },
    {
      label: '5年级',
      age: '9',
      value: '5',
    },
    {
      label: '6年级',
      age: '10',
      value: '6',
    },
    {
      label: '7年级',
      age: '11',
      value: '7',
    },
  ],
  '+44': [
    {
      label: '1年级',
      age: '5',
      value: '1',
    },
    {
      label: '2年级',
      age: '6',
      value: '2',
    },
    {
      label: '3年级',
      age: '7',
      value: '3',
    },
    {
      label: '4年级',
      age: '8',
      value: '4',
    },
    {
      label: '5年级',
      age: '9',
      value: '5',
    },
    {
      label: '6年级',
      age: '10',
      value: '6',
    },
    {
      label: '7年级',
      age: '11',
      value: '7',
    },
  ],
  '+65': [
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
    {
      label: '初中',
      age: '12',
      value: '7',
    },
  ],
  other: [
    {
      label: '幼儿园',
      age: '5',
      value: '0',
    },
    {
      label: '1年级',
      age: '6',
      value: '1',
    },
    {
      label: '2年级',
      age: '7',
      value: '2',
    },
    {
      label: '3年级',
      age: '8',
      value: '3',
    },
    {
      label: '4年级',
      age: '9',
      value: '4',
    },
    {
      label: '5年级',
      age: '10',
      value: '5',
    },
    {
      label: '6年级',
      age: '11',
      value: '6',
    },
  ],
};

// 英文-EN-国家-学生年级映射
const ENGLISH_EN_COUNTRY_STUDENT_GRADE = {
  '+61': [
    {
      age: '5',
      label: 'Kindergarten',
      value: '0',
    },
    {
      age: '6',
      label: 'Year 1',
      value: '1',
    },
    {
      age: '7',
      label: 'Year 2',
      value: '2',
    },
    {
      age: '8',
      label: 'Year 3',
      value: '3',
    },
    {
      age: '9',
      label: 'Year 4',
      value: '4',
    },
    {
      age: '10',
      label: 'Year 5',
      value: '5',
    },
    {
      age: '11',
      label: 'Year 6',
      value: '6',
    },
  ],
  '+64': [
    {
      age: '5',
      label: 'Year 1',
      value: '1',
    },
    {
      age: '6',
      label: 'Year 2',
      value: '2',
    },
    {
      age: '7',
      label: 'Year 3',
      value: '3',
    },
    {
      age: '8',
      label: 'Year 4',
      value: '4',
    },
    {
      age: '9',
      label: 'Year 5',
      value: '5',
    },
    {
      age: '10',
      label: 'Year 6',
      value: '6',
    },
    {
      age: '11',
      label: 'Year 7',
      value: '7',
    },
  ],
  '+44': [
    {
      age: '5',
      label: 'Year 1',
      value: '1',
    },
    {
      age: '6',
      label: 'Year 2',
      value: '2',
    },
    {
      age: '7',
      label: 'Year 3',
      value: '3',
    },
    {
      age: '8',
      label: 'Year 4',
      value: '4',
    },
    {
      age: '9',
      label: 'Year 5',
      value: '5',
    },
    {
      age: '10',
      label: 'Year 6',
      value: '6',
    },
    {
      age: '11',
      label: 'Year 7',
      value: '7',
    },
  ],
  '+65': [
    {
      age: '6',
      label: 'Primary 1',
      value: '1',
    },
    {
      age: '7',
      label: 'Primary 2',
      value: '2',
    },
    {
      age: '8',
      label: 'Primary 3',
      value: '3',
    },
    {
      age: '9',
      label: 'Primary 4',
      value: '4',
    },
    {
      age: '10',
      label: 'Primary 5',
      value: '5',
    },
    {
      age: '11',
      label: 'Primary 6',
      value: '6',
    },
    {
      age: '12',
      label: 'Secondary 1',
      value: '7',
    },
  ],
  other: [
    {
      age: '5',
      label: 'Kindergarten',
      value: '0',
    },
    {
      age: '6',
      label: 'Grade 1',
      value: '1',
    },
    {
      age: '7',
      label: 'Grade 2',
      value: '2',
    },
    {
      age: '8',
      label: 'Grade 3',
      value: '3',
    },
    {
      age: '9',
      label: 'Grade 4',
      value: '4',
    },
    {
      age: '10',
      label: 'Grade 5',
      value: '5',
    },
    {
      age: '11',
      label: 'Grade 6',
      value: '6',
    },
  ],
};

// 多科多娃模式：英文/数学共用年龄范围 4-17
const AGE_MULTI_CHILD_ZH = Array.from({ length: 14 }, (_, i) => ({
  label: `${i + 4}岁`,
  value: `${i + 4}`,
}));

const AGE_MULTI_CHILD_EN = Array.from({ length: 14 }, (_, i) => ({
  label: `${i + 4} years old`,
  value: `${i + 4}`,
}));

// 授课语言（仅数学科目）：value 为后端契约字面量，Chinese=中文授课(CMS)，English=英文授课(A系列)
export type TeachingLanguage = 'Chinese' | 'English';

const TEACHING_LANGUAGE_ZH: { label: string; value: TeachingLanguage }[] = [
  { label: '中文授课', value: 'Chinese' },
  { label: '英文授课', value: 'English' },
];

const TEACHING_LANGUAGE_EN: { label: string; value: TeachingLanguage }[] = [
  { label: 'Chinese', value: 'Chinese' },
  { label: 'English', value: 'English' },
];

export {
  GRADE,
  GRADE_ZH,
  GRADE_EN,
  ENGLISH_GRADE_EN,
  ENGLISH_GRADE_ZH,
  CHINESE_LEVEL,
  MOTHER_LANGUAGE,
  CHINESE_LEVEL_EN,
  AGE_CHINESE_ZH,
  AGE_CHINESE_EN,
  AGE_MATH_SERVICE_ZH,
  AGE_MATH_SERVICE_EN,
  AGE_ENGLISH_SERVICE_ZH,
  AGE_ENGLISH_SERVICE_EN,
  AGE_MULTI_CHILD_ZH,
  AGE_MULTI_CHILD_EN,
  TEACHING_LANGUAGE_ZH,
  TEACHING_LANGUAGE_EN,
  MATH_ZH_COUNTRY_STUDENT_GRADE,
  MATH_EN_COUNTRY_STUDENT_GRADE,
  ENGLISH_CH_COUNTRY_STUDENT_GRADE,
  ENGLISH_EN_COUNTRY_STUDENT_GRADE,
};
